import { render, staticRenderFns } from "./checkout.component.vue?vue&type=template&id=06e5f0be&scoped=true"
import script from "./checkout.component.ts?vue&type=script&lang=ts&external"
export * from "./checkout.component.ts?vue&type=script&lang=ts&external"
import style0 from "./checkout.component.vue?vue&type=style&index=0&id=06e5f0be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5f0be",
  null
  
)

export default component.exports